<template>
  <form class="nameform m-center" @submit="submit">
    <div class="content flex flex-wrap mb-10">
      <h1 class="mb-6">Carta Prepagata</h1>

      <div
        class="w-full mb-3"
        v-for="term in cardTerms.filter(c => c.radio === false)"
        :key="term.id"
      >
        <a class="link" @click="openTerm(term.id)">{{ term.description }}</a>
      </div>

      <!-- TODO: check this loop out! we can have multiple items (?) and just one checkbox model (privacyConsentRead) -->
      <!-- TODO: is that correct? -->
      <div
        class="w-full mt-5 mb-3"
        v-for="term in cardTerms.filter(c => c.mandatory && c.radio === true)"
        :key="term.id"
      >
        <div class="tnb-checkbox">
          <div class="inline-flex">
            <input
              type="checkbox"
              id="privacyConsentRead"
              v-model="term.checked"
              @change="toggleCheckbox('privacyConsentRead')"
            />
            <label for="privacyConsentRead">{{ term.description }}</label>
          </div>
        </div>
      </div>

      <div class="w-full mt-8" v-for="term in nonMandatoryTerms" :key="term.id">
        <p class="text-grey mb-3">{{ term.description }}</p>
        <div class="tnb-input tnb-radio">
          <label :for="term.id">Dai il consenso</label>
          <div>
            <div class="tnb-radio-container mr-8">
              <input
                type="radio"
                id="yes"
                :name="term.id"
                :value="true"
                v-model="term.checked"
              />
              <label for="yes">Si</label>
            </div>
            <div class="tnb-radio-container">
              <input
                type="radio"
                id="no"
                :name="term.id"
                :value="false"
                v-model="term.checked"
              />
              <label for="no">No</label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="page-footer">
      <button class="btn" type="submit" :disabled="$v.$invalid">
        Prosegui
      </button>
    </div>
  </form>
</template>

<script>
import { sameAs } from "vuelidate/lib/validators";
import DocumentsService from "@/services/DocumentsService";
import RegistrationService from "@/services/RegistrationService";
import UtilityService from "@/services/UtilityService";

export default {
  name: "CardDocumentation",
  data() {
    return {
      cardTerms: [],
      privacyTerm: {},
      nonMandatoryTerms: [],
      cardDocuments: [],
      flowDocs: [],
      privacyConsentRead: false
    };
  },
  validations: {
    privacyTerm: {
      checked: {
        sameAs: sameAs(() => true)
      }
    }
  },
  async mounted() {
    const asTutor = await RegistrationService.asTutor();
    const regId = RegistrationService.getCurrentRegistrationId();
    const registrationStatus = asTutor?.data?.filter(d => d.id === regId)[0];
    const acceptedTerms = registrationStatus.acceptedTerms.split(",");
    DocumentsService.getTerms().then(response => {
      this.cardTerms = response.terms
        .filter(
          t =>
            t.id === 520 ||
            t.id === 121 ||
            t.id === 122 ||
            t.id === 123 ||
            t.id === 124
        )
        .map(c => {
          c.checked = acceptedTerms.indexOf(c.id.toString()) >= 0;
          return c;
        });

      this.privacyTerm = this.cardTerms.filter(t => t.id === 121)[0];
      this.nonMandatoryTerms = this.cardTerms.filter(
        c => c.mandatory === false && c.radio === true
      );
    });

    DocumentsService.getStaticContracts().then(response => {
      this.cardDocuments = response.staticContracts.filter(
        d => d.type === "UNICO_CSI"
      );
    });
  },
  methods: {
    toggleCheckbox(checkboxKey) {
      this[checkboxKey] = !this[checkboxKey];
    },
    openTerm(id) {
      DocumentsService.openTerm(id);
      /* } */
    },
    openStaticContract(id) {
      var url = DocumentsService.getStaticContractUrlFromId(id);
      DocumentsService.openDocument(url);
    },

    submit() {
      event.preventDefault();
      if (this.loading) return;
      this.loading = true;

      if (this.$store.state.user.minor) {
        this.stepCompleted();
        this.loading = false;
        return;
      }

      const radios = this.cardTerms.filter(t => t.radio === true);
      const req = {
        acceptedTermIds: radios.filter(r => r.checked).map(r => r.id),
        rejectedTermIds: radios.filter(r => !r.checked).map(r => r.id)
      };

      RegistrationService.setTerms(req).then(
        () => {
          this.stepCompleted();
        },
        error => {
          //TODO: error handling
          console.log(error);
          this.loading = false;
          UtilityService.showDefaultError(error);
        }
      );
    },
    stepCompleted() {
      this.$root.$emit("submitStep");
    }
  }
};
</script>
<style lang="less" scoped>
.tnb-radio {
  align-items: center;
  label {
    margin: 0;
  }
}
</style>
